<mat-card class="summary-card ytd">
	<div class="summary-title ytd">YTD WEEKLY AVERAGE (Up till last week)</div>
	<div class="summary-content">
		<div class="summary-metric">
			<span class="metric-label">SALES</span>
			<span class="metric-value">{{ ytdWeeklySalesTop | number:'1.0-0' }}</span>
			<span class="metric-sub" [innerHTML]="ytdWeeklySalesBottom"></span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">LABOUR %</span>
			<span class="metric-value">{{ ytdWeeklyLabourPerTop }}</span>
			<span class="metric-sub" [innerHTML]="ytdWeeklyLabourPerBottom"></span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">ONLINE SALES</span>
			<span class="metric-value">{{ ytdWeeklyOnlineSalesTop | currency:'USD':'symbol':'1.0-0' }}</span>
			<span class="metric-sub" [innerHTML]="ytdWeeklyOnlineSalesBottom"></span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">ONLINE CUSTOMER ORDERS</span>
			<span class="metric-value">{{ ytdWeeklyOnlineCustomerOrdersTop | number:'1.0-0' }}</span>
			<span class="metric-sub" [innerHTML]="ytdWeeklyOnlineCustomerOrdersBottom"></span>
		</div>
		@if (this.shopType!="DT") {
		<div class="summary-metric">
			<span class="metric-label">DRIVE-THRU SALES</span>
			<span class="metric-value">{{ ytdWeeklyDriveThruSalesTop | currency:'USD':'symbol':'1.0-0' }}</span>
			<span class="metric-sub" [innerHTML]="ytdWeeklyDriveThruSalesBottom"></span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">DRIVE-THRU ORDERS</span>
			<span class="metric-value">{{ ytdWeeklyDriveThruOrdersTop | number:'1.0-0' }}</span>
			<span class="metric-sub" [innerHTML]="ytdWeeklyDriveThruOrdersBottom"></span>
		</div>
		}
		<div class="summary-metric">
			<span class="metric-label">TARGET</span>
			<span class="metric-value">{{ ytdWeeklyTargetTop | number:'1.0-0' }}</span>
			<span class="metric-sub" [innerHTML]="ytdWeeklyTargetBottom"></span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">LABOUR HOURS</span>
			<span class="metric-value">{{ ytdWeeklyLabourHoursTop | number:'1.0-0' }}</span>
			<span class="metric-sub" [innerHTML]="ytdWeeklyLabourHoursBottom"></span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">CUSTOMER ORDERS</span>
			<span class="metric-value">{{ ytdWeeklyCustomerOrdersTop | number:'1.0-0' }}</span>
			<span class="metric-sub" [innerHTML]="ytdWeeklyCustomerOrdersBottom"></span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">LABOUR COST</span>
			<span class="metric-value">{{ ytdWeeklyLabourCostTop | currency:'USD':'symbol':'1.0-0' }}</span>
			<span class="metric-sub" [innerHTML]="ytdWeeklyLabourCostBottom"></span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">ITEM SOLD</span>
			<span class="metric-value">{{ ytdWeeklyItemsSoldTop | number:'1.0-0' }}</span>
			<span class="metric-sub" [innerHTML]="ytdWeeklyItemsSoldBottom"></span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">SALES / LABOUR HOUR</span>
			<span class="metric-value">{{ ytdWeeklySalesByLabourHourTop | currency:'USD':'symbol':'1.2-2' }}</span>
			<span class="metric-sub" [innerHTML]="ytdWeeklySalesByLabourHourBottom"></span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">SALES VALUE / ITEM</span>
			<span class="metric-value">{{ ytdWeeklySalesValueByItemTop | currency:'USD':'symbol':'1.2-2' }}</span>
			<span class="metric-sub" [innerHTML]="ytdWeeklySalesValueByItemBottom"></span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">AVERAGE ORDER $</span>
			<span class="metric-value">{{ ytdWeeklyAverageOrderTop | currency:'USD':'symbol':'1.2-2' }}</span>
			<span class="metric-sub" [innerHTML]="ytdWeeklyAverageOrderBottom"></span>
		</div>
	</div>
</mat-card>